import { Box, Container, TextField } from "@mui/material"
import { TextareaAutosize } from "@mui/base/TextareaAutosize"

import { useField } from "formik"
import React from "react"

interface Props {
  name: string
  minRows: string
  label?: string
}

export default function MyTextArea(props: Props) {
  const [field, meta] = useField(props.name)
  return (
    <Box sx={{ my: 1, width: { xs: "100%", md: "40em" } }}>
      <TextField
        {...field}
        {...props}
        variant="outlined"
        // type="text"
        error={meta.touched && !!meta.error}
        helperText={meta.touched && meta.error ? meta.error : null}
        fullWidth
        multiline
      />
    </Box>
  )
}
